<template>
  <div class="learn" ref="learnRef">
    <template v-if="$route.path === '/learn'">
      <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="易经课堂"></Header>

      <section class="tab" ref="tabRef">
        <div
          class="item"
          @click="gotoPage('/course', '/pages/learn/course/course')">
          <div class="icon course"></div>
          <div class="title">课程学习</div>
        </div>
        <div
          class="item"
          @click="gotoPage('/article', '/pages/learn/article/article')">
          <div class="icon article"></div>
          <div class="title">精选分享</div>
        </div>
        <div
          class="item"
          @click="gotoPage('/notification', '/pages/learn/notification/notification')">
          <div class="icon notification"></div>
          <div class="title">课程通知</div>
        </div>
      </section>

      <section class="content" ref="contentRef">
        <cube-scroll ref="scrollRef" :options="scrollOptions" @pulling-down="onPullingDown">
          <course-list-wrapper title="课程学习" to="/course" mini-path="/pages/learn/course/course" :courses="courseList"></course-list-wrapper>
          <course-list-wrapper title="精选分享" to="/article" mini-path="/pages/learn/article/article" :courses="articleList"></course-list-wrapper>
          <course-list-wrapper title="课程通知" to="/notification" mini-path="/pages/learn/notification/notification" :courses="notificationList"></course-list-wrapper>
        </cube-scroll>
      </section>
    </template>
  </div>
</template>

<script>
import Header from '@/components/Header'
import CourseListWrapper from '@/components/CourseListWrapper'
import { queryCourseList, queryNotifyList } from '@/api/course'

export default {
  name: 'Learn',
  components: {
    CourseListWrapper,
    Header
  },
  data () {
    return {
      scrollOptions: {
        pullDownRefresh: {
          txt: '刷新成功'
        }
      },

      courseList: [],
      articleList: [],
      notificationList: []
    }
  },
  mounted () {
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }

    if (this.$route.path === '/learn') {
      this.$nextTick(() => {
        const navBarHeight = this.$refs.navBarRef ? this.$refs.navBarRef.$el.clientHeight : 0
        this.$refs.contentRef.style.height = (this.$refs.learnRef.clientHeight - navBarHeight - this.$refs.tabRef.clientHeight) + 'px'
      })
    }

    if (this.$store.state.token.token !== '' && this.$store.state.token.token !== undefined) {
      this.getCourseData()
      this.getArticleData()
      this.getNotificationData()
    }
  },
  methods: {
    onPullingDown () {
      // 模拟更新数据

      this.getCourseData()
      this.getArticleData()
      this.getNotificationData()

      setTimeout(() => {
        console.log('更新数据。。。')
        this.$refs.scrollRef.forceUpdate()
      }, 1000)
    },

    // 课程学习
    getCourseData () {
      queryCourseList({
        page: 1,
        size: 3
      }).then((res) => {
        // const records = res.data.records.filter(item => {
        //   return item.typeCode === '0' || item.typeCode === '1'
        // })
        const records = res.data.records
        records.sort(this.compare('sort'))
        this.courseList.splice(0)
        records.forEach((item, idx) => {
          const course = {
            id: item.courseId,
            title: item.name,
            url: item.cover.resUrl,
            // url:'https://source.unsplash.com/random',
            read: item.readNum,
            comment: item.commentNum,
            type: item.typeCode,
            medias: item.medias
          }
          this.courseList.push(course)
        })
      })
    },

    // 精选分享
    getArticleData () {
      queryCourseList({
        typeCode: '2',
        page: 1,
        size: 3
      }).then((res) => {
        const records = res.data.records
        records.sort(this.compare('sort'))
        this.articleList.splice(0)
        records.forEach((item, idx) => {
          const course = {
            id: item.courseId,
            title: item.name,
            url: item.cover.resUrl,
            // url:'https://source.unsplash.com/random',
            read: item.readNum,
            comment: item.commentNum,
            type: item.typeCode
          }
          this.articleList.push(course)
        })
      })
    },

    // 课程通知
    getNotificationData () {
      queryNotifyList({
        page: 1,
        size: 3
      }).then((res) => {
        const records = res.data.records
        records.sort(this.compare('sort'))
        this.notificationList.splice(0)
        records.forEach((item, idx) => {
          const course = {
            id: item.notifyId,
            title: item.name,
            url: item.cover.resUrl,
            // url:'https://source.unsplash.com/random',
            read: item.readNum,
            comment: item.shareNum,
            type: '4'
          }
          this.notificationList.push(course)
        })
      })
    },
    compare (attr) {
      return function (a, b) {
        var val1 = a[attr]
        var val2 = b[attr]
        return val1 - val2
      }
    },

    gotoPage (url, miniUrl) {
      if (this.$route.query.platform === 'mini') {
        wx.miniProgram.navigateTo({ url: miniUrl })
      } else {
        this.$router.push({ path: url })
      }
    }
  }
}
</script>

<style lang="stylus">
body
  background-color #f7f7f7 !important
.learn
  height 100%
  .tab
    height 75px
    display flex
    background-color #fff
    .item
      flex-grow 1
      .icon
        width 36px
        height 36px
        margin 8px auto
      .icon.course
        background url("~@/assets/images/icons/icon-kcxx.png") no-repeat center
        background-size 36px 36px
      .icon.article
        background url("~@/assets/images/icons/icon-yjtw.png") no-repeat center
        background-size 36px 36px
      .icon.notification
        background url("~@/assets/images/icons/icon-kctz.png") no-repeat center
        background-size 36px 36px
      .title
        color #9D9D9D
</style>
